import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import {
    BooleanModel,
    ConfigConstants,
    ConfirmationComplaintsP58Model,
    EventService,
    ODataModel,
    RadioModel,
    resetCompositeModel,
    resetODataModel,
    TextModel,
} from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';

@Component({
    selector: 'pace-confirmation-complaints-p58',
    templateUrl: './confirmation-complaints-p58.component.html',
    styleUrls: ['./confirmation-complaints-p58.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ConfirmationComplaintsP58Component implements OnInit {
    @Input()
    public model: ConfirmationComplaintsP58Model;

    @Input()
    public parentForm: FormArray;

    public strings: {
        complaintsHeader: string;
    };

    public readonly optionYes = ConfigConstants.optionYes;

    public showCommonQuestionnaire = false;

    public faClock = faClock;
    public constructor(
        private readonly translate: TranslateService,
        private readonly eventService: EventService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}

    public ngOnInit(): void {
        this.strings = {
            complaintsHeader: <string>this.translate.instant('CONFIRMATION_COMPLAINTS_LABEL'),
        };
    }

    public optionChange(): void {
        this.model.updateAllowedQuestionsAndCalculatePriority();
        this.showCommonQuestionnaire = this.model.showCommonQuestionnaire();
        if (!this.showCommonQuestionnaire) {
            // QcaCreationSet cannot be reset to not lose the content in all fields that are only set during construction,
            // eg. notification number, equipment number, and so on. GW will ignore the contents of QcaCreationSet if the
            // other two subobjects QcaFieldsSet and QcaTextsSet do not contain values.
            resetCompositeModel(this.model.qcaFields);
            resetCompositeModel(this.model.qcaTexts);
        }
        this.eventService.triggerComplaintOptionSelectionChanged(this.showCommonQuestionnaire);
        this.parentForm.controls.forEach((control) => control.updateValueAndValidity());
        this.changeDetectorRef.detectChanges();
    }

    public updateInitiatedBy(): void {
        this.model.updateInitiatedBy();
    }

    /**
     * Wipe the value of dependent odata fields; used when fields are hidden by radio buttons
     *
     * @param decider the radio input that controls dependent fields
     * @param dependentFields array of dependent fields to wipe
     */
    public clearDependentFields(decider: RadioModel<TextModel> | BooleanModel, dependentFields: ODataModel[]): void {
        const hideDependentFields =
            decider instanceof RadioModel ? decider.getSelectedValue() !== this.optionYes : !decider.value;

        if (hideDependentFields) {
            dependentFields.forEach((f) => resetODataModel(f));
        }
    }
}
